var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fileUrl)?_c('embed',{attrs:{"src":_vm.fileUrl,"width":"800px","height":"2100px"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }